import { ArticleParagraph1, Button, useDeviceType } from '@cian/ui-kit';
import styles from './styles.css';
import React from 'react';
import { ContainerInner } from 'shared/components/ContainerInner';
import cn from 'clsx';
import { Breadcrumbs, type IBreadcrumbNavItem } from 'shared/components/Breadcrumbs';
import { ETestIds } from 'shared/constants/testIds';

interface IPresentationBlockProps {
  title: string;
  description: string;
  handleClickButton: () => void;
  breadcrumbs: IBreadcrumbNavItem[];
}

const PRESENTATION_CAT_SRC = 'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/cat.png';

export const PresentationBlock: React.FC<IPresentationBlockProps> = ({
  title,
  description,
  handleClickButton,
  breadcrumbs,
}) => {
  const deviceType = useDeviceType();
  const hasBreadcrumbs = breadcrumbs.length > 0;

  return (
    <div className={cn(styles['wrapper'], styles[deviceType])}>
      <ContainerInner>
        <div className={cn(styles['container'], styles[deviceType])} data-testid={ETestIds.PresentationBlock}>
          {hasBreadcrumbs && (
            <div className={cn(styles['breadcrumbs-container'], styles[deviceType])}>
              <Breadcrumbs
                items={[{ url: '/ipoteka/', anchor: 'Ипотека', color: 'text-secondary-disabled' }, ...breadcrumbs]}
              />
            </div>
          )}
          <div className={cn(styles['img'], styles[deviceType])}>
            <img src={PRESENTATION_CAT_SRC} alt="" decoding="async" data-testid={ETestIds.PresentationImg} />
          </div>
          <div className={cn(styles['widget'], styles[deviceType])}>
            <div className={styles['widget-main']}>
              <h1 className={cn(styles['title'], styles[deviceType])}>{title}</h1>
              <ArticleParagraph1>{description}</ArticleParagraph1>
              <div className={cn(styles['btn-wrapper'], styles[deviceType])}>
                <Button size={'L'} fullWidth onClick={handleClickButton} data-testid={ETestIds.PresentationBtn}>
                  Подобрать предложение
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ContainerInner>
    </div>
  );
};
